
	[...document.querySelectorAll( '.js-check-for-plus') ].forEach( ( item ) => {
		if ( item.innerHTML.includes( '+' ) ) item.innerHTML = item.innerHTML.replace( '+', '<span class="inline-plus">+</span>' );
	} );